import React, { ChangeEvent } from "react";
import { Button, Col, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { toast } from "react-toastify";
import { AgreeTerms, ContactNumber, Continue, Email, FirstName, LastName, State, ZipCode } from "../../../../../../../constants";
import { ActiveCallbackProp, BillingFormData } from "../../../../../../../types/Forms";
import { useForm } from "react-hook-form";

const PersonalInfoForm: React.FC<ActiveCallbackProp> = ({ activeCallBack }) => {
  const { register, formState: { errors }, setValue, watch, handleSubmit} = useForm<BillingFormData>({});
  
  const formData = watch();  

  const updateFormData = (event: ChangeEvent<HTMLInputElement>) => {
    let name = event.target.name;
    let value = name === "agreeTerms" ? event.target.checked : event.target.value;
      setValue(name as keyof BillingFormData, value as boolean, { 
          shouldValidate: true, 
          shouldDirty: true 
        });
  };
  const handleNextButton = handleSubmit(
    () => {
      if (formData.firstName !== "" && formData.lastName !== "" && formData.contact !== "" && formData.email !== "" && formData.state !== "" && formData.zip !== "" && formData.agreeTerms !== false) activeCallBack(2);
    },
    () => {
      toast.error("Please fill out all the fields before moving on to the next step");
    }
  );
  return (
    <Form onSubmit={(e) => e.preventDefault()} className="needs-validation" noValidate>
      <Row className="g-3">
        <Col xl="4" sm="6">
          <Label>{FirstName}<span className="txt-danger">*</span></Label>
          <Input {...register("firstName", { required: "First name is required" })} value={formData.firstName} type="text" placeholder="Enter first name" onChange={updateFormData} />
          {errors.firstName && <span className="text-danger">{errors.firstName.message}</span>}
        </Col>
        <Col xl="4" sm="6">
          <Label>{LastName}<span className="txt-danger">*</span></Label>
          <Input {...register("lastName", { required: "Last name is required" })} type="text" placeholder="Enter last name" name="lastName" value={formData.lastName} onChange={updateFormData} />
          {errors.lastName && <span className="text-danger">{errors.lastName.message}</span>}
        </Col>
        <Col xl="4" xs="12">
          <Label>{Email}<span className="txt-danger">*</span></Label>
          <Input {...register("email", { required: "Email is required" })} value={formData.email} type="email" placeholder="johan@example.com" onChange={updateFormData} />
          {errors.email && <span className="text-danger">{errors.email.message}</span>}
        </Col>
        <Col xl="5" sm="4">
          <Label>{State}</Label>
         <Input {...register("state", { required: "State is required" })} value={formData.state} type="select" onChange={updateFormData} >
            <option value={""}>{"Choose..."}</option>
            <option value={"USA"}>{"USA "}</option>
            <option value={"U.K"}>{"U.K "}</option>
            <option value={"U.S"}>{"U.S"}</option>
          </Input>
          {errors.state && <span className="text-danger">{errors.state.message}</span>}
        </Col>
        <Col xl="3" sm="4">
          <Label>{ZipCode}</Label>
          <Input {...register("zip", { required: "Zip is required" })} value={formData.zip} type="text" onChange={updateFormData} />
          {errors.zip && <span className="text-danger">{errors.zip.message}</span>}
        </Col>
        <Col sm="4">
          <Label>{ContactNumber}</Label>
          <Input {...register("contact", { required: "Contact number is required" })} value={formData.contact} type="number" placeholder="Enter number" onChange={updateFormData} />
          {errors.contact && <span className="text-danger">{errors.contact.message}</span>}
        </Col>
        <Col xs="12">
          <FormGroup check>
            <Input className="checkbox-primary" id="invalid-check-wizard" type="checkbox" {...register("agreeTerms", { required: true })} onChange={updateFormData} required/>
            <Label className={`${formData.agreeTerms? "mb-0 d-block": "text-danger mb-0"}`} htmlFor="invalid-check-wizard" check>{AgreeTerms}</Label>
          </FormGroup>
        </Col>
        <Col xs="12" className="text-end">
          <Button color="primary" onClick={handleNextButton}>{Continue}</Button>
        </Col>
      </Row>
    </Form>
  );
};

export default PersonalInfoForm;
